@if(!isMobile){
    <div [dir]="currentLang ? (currentLang == 'iw' ? 'rtl' : 'ltr') : 'auto'">
        <form class="sitesOpt" [formGroup]="searchUserForm" rtlDiv>
          <mat-select panelClass="myPanelClass" placeholder="{{formValueForUser}}" #selectSites formControlName="userType" multiple rtlDiv>
            <mat-select-trigger rtlDiv>
              {{formValueForUser}}
            </mat-select-trigger>
            <div class="sites-menu-header" rtlDiv>
              <div class='search-input-sites' rtlDiv>
                <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                <input id="filter-input" class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="applyFilter($event.target)" rtlDiv>
              </div>
              <mat-option class="all-site-option" #allSelected (click)="toggleAllSelection()" [value]="0" rtlDiv>{{ 'TITLES.ALL_SIES' | translate }} ({{sitesListFilter.length}})</mat-option>
            </div> 
            <div class="sites-menu-list" rtlDiv>        
              @for(group of sitesHierarchy;track group){
                <mat-optgroup>
                    @if(group.names.length > 1 && group.display){
                        <div class="group-site-option" rtlDiv>
                            <mat-checkbox [checked]="group.selected" (change)="toggleSelection($event, group)" (click)="$event.stopPropagation()">
                              <span class="group-label"> {{group.letter}} </span>
                            </mat-checkbox>
                            <div class="option-btns-container">
                              <div class="launch-btn" (click)="launchSite(group); $event.stopPropagation()">
                                {{ 'TITLES.LAUNCH' | translate }}
                              </div>
                              <div class="star-btns-container">
                                @if(isGroupAllViewed(group)){
                                  <img rtlDiv src="assets/images/sidemenu/star-fill.svg" alt="star-fill" (click)="toggleGroupStar(group);$event.stopPropagation()"/>
                                }@else{
                                  <img class="star-btn" rtlDiv src="assets/images/sidemenu/star.svg" alt="star" (click)="toggleGroupStar(group);$event.stopPropagation()"/>   
                                }
                              </div>
                            </div>
                        </div> 
                    }   
                    <ng-container>
                      @for(site of group.names;track site){
                        @if(site.isFirstNonViewed && userViewedSites.length > 0){
                          <hr class="hr-line">
                        }
                        <mat-option [ngClass]="{'sub-option':group.names.length > 1,'hide': !group.display}" class="site-option" rtlDiv [value]="site" (click)="tosslePerOne(site)">
                          <div>{{site.site_name}}</div>
                          <div class="option-btns-container">
                            <div class="launch-btn" (click)="launchSite(site); $event.stopPropagation()">
                              {{ 'TITLES.LAUNCH' | translate }}
                            </div>                                  
                            <div class="star-btns-container">
                              @if(site.isViewed){
                                <img rtlDiv src="assets/images/sidemenu/star-fill.svg" alt="star-fill" (click)="toggleStar(site);$event.stopPropagation()"/>
                              }@else{
                                <img class="star-btn" rtlDiv src="assets/images/sidemenu/star.svg" alt="star" (click)="toggleStar(site);$event.stopPropagation()"/>   
                              }
                            </div>
                          </div>
                        </mat-option> 
                      } 
                    </ng-container> 
                </mat-optgroup>
              }
            </div>
            <div class="apply-option" (click)="applySitesChosenBtn()"><button [ngClass]="{'noClick':searchUserForm.getRawValue()['userType'] && searchUserForm.getRawValue()['userType'].length == 0}" class="apply-btn"><span class="apply-txt">{{ 'TITLES.APPLY' | translate }}</span></button></div>            
          </mat-select>
          <div class="sites-chosen-container">
            @for(site of firstFourSites;track site){
              @if(site.isViewed){
                <div (click)="launchSite(site); $event.stopPropagation()" 
                    [ngClass]="{'selectedSite' : isPartOfSearchUserForm(site), 'notSelectedSite' : !isPartOfSearchUserForm(site)}" 
                    class="site-chosen-item">
                  {{site.site_name}}
                </div>
              }
            }
            @if(hasMoreSites){
              <div class="more-sites-indicator">
                +{{remainingSitesCount}}
                <div class="remaining-sites-tooltip">
                  @for(site of remainingSites; track site.site_id) {
                    <div (click)="launchSite(site)" 
                          [ngClass]="{'selectedSite' : isPartOfSearchUserForm(site), 'notSelectedSite' : !isPartOfSearchUserForm(site)}" 
                          class="site-chosen-item-tooltip">
                      {{site.site_name}}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </form>
      </div>
}

@if(isMobile){
  <div>
      <form class="mobile-sitesOpt" [formGroup]="searchUserForm" rtlDiv>
        <mat-select panelClass="myPanelClass-mobile" placeholder="{{formValueForUser}}" #selectSites formControlName="userType" multiple rtlDiv>
          <mat-select-trigger rtlDiv>
            {{formValueForUser}}
          </mat-select-trigger>
          <div>
            <div class="mobile-sites-menu-header" rtlDiv>
              <div class='search-input-sites' rtlDiv>
                <input id="filter-input" class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="applyFilter($event.target)" rtlDiv>
                <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
              </div>
              <mat-option class="all-site-option" #allSelected (click)="toggleAllSelection()" [value]="0" rtlDiv>{{ 'TITLES.ALL_SIES' | translate }} ({{sitesListFilter.length}})</mat-option>
            </div> 
            <div class="mobile-sites-menu-list">
              @for(group of sitesHierarchy;track group){
                <mat-optgroup>
                  @if(group.names.length > 1 && group.display){
                    <div class="group-site-option" rtlDiv>
                        <mat-checkbox [checked]="group.selected" (change)="toggleSelection($event, group)" (click)="$event.stopPropagation()">
                          <span class="group-label"> {{group.letter}} </span>
                        </mat-checkbox>
                        <div class="star-btns-container">
                          @if(isGroupAllViewed(group)){
                            <img rtlDiv src="assets/images/sidemenu/star-fill.svg" alt="star-fill" (click)="toggleGroupStar(group);$event.stopPropagation()"/>
                          }@else{
                            <img rtlDiv src="assets/images/sidemenu/star.svg" alt="star" (click)="toggleGroupStar(group);$event.stopPropagation()"/>   
                          }
                        </div>
                    </div>  
                  }
                  <ng-container>
                    @for(site of group.names;track site){
                      @if(site.isFirstNonViewed && userViewedSites.length > 0){
                        <hr class="hr-line">
                      }
                      <mat-option [ngClass]="{'sub-option':group.names.length > 1,'hide': !group.display}" class="site-option" rtlDiv [value]="site" (click)="tosslePerOne(site)">
                        <div>{{site.site_name}}</div>
                        <div class="option-btns-container">                             
                          <div class="star-btns-container">
                            @if(site.isViewed){
                              <img rtlDiv src="assets/images/sidemenu/star-fill.svg" alt="star-fill" (click)="toggleStar(site);$event.stopPropagation()"/>
                            }@else{
                              <img rtlDiv src="assets/images/sidemenu/star.svg" alt="star" (click)="toggleStar(site);$event.stopPropagation()"/>   
                            }
                          </div>
                        </div>
                      </mat-option> 
                    } 
                  </ng-container> 
                </mat-optgroup>
              }
            </div>
            <div class="apply-option" (click)="applySitesChosenBtn()"><button class="apply-btn"><span class="apply-txt">{{ 'TITLES.APPLY' | translate }}</span></button></div>  
          </div>          
        </mat-select>
      </form>
      <div class="mobile-sites-chosen-container">
        @for(site of sitesListFilter;track site){
          @if(site.isViewed){
            <div (click)="launchSite(site); $event.stopPropagation()" 
                [ngClass]="{'selectedSite' : isPartOfSearchUserForm(site), 'notSelectedSite' : !isPartOfSearchUserForm(site)}" 
                class="site-chosen-item">
              {{site.site_name}}
            </div>
          }
        }
      </div>
    </div>
}


